module.exports = __webpack_public_path__ + "static/school-61f4466768a8af2f5524c5a44eaa89be.gif";